import React from 'react';

import { RelativePeriod } from '../comparison-period-selector/Types';
import DataLastUpdated from '../data-last-updated/DataLastUpdated';
import FilteredPeriod from '../filtered-period/FilteredPeriod';
import PanelType from '../panel-type/PanelType';
import { Periodicity } from '../time-period-selector/PeriodsTypes';

import getComparisonPeriod, { PeriodFormat } from './GetComparisonPeriod';
import { ScopeMetadata } from '@utils/pageConfig/Types';
import { BaseTimePeriod } from '@services/FiltersTypes';

export interface FilterSelectionNoteProps {
  selectedPeriodicity?: Periodicity;
  selectedPeriod: BaseTimePeriod;
  comparisonPeriodType: RelativePeriod | BaseTimePeriod;
  scopeMetadata?: ScopeMetadata;
  periodFormat?: PeriodFormat;
  isDisplayNoComparisonLabel?: boolean;
}

const FilterSelectionNote: React.FC<FilterSelectionNoteProps> = ({
  selectedPeriodicity,
  selectedPeriod,
  comparisonPeriodType,
  scopeMetadata,
  periodFormat,
  isDisplayNoComparisonLabel,
}) => {
  const comparisonPeriod = getComparisonPeriod(selectedPeriod, selectedPeriodicity, comparisonPeriodType, periodFormat);

  // using selectedPeriod.label to display as the return value from backend has changed
  return selectedPeriod && selectedPeriod.label !== '' ? (
    <div data-testid="filter-selection-note">
      <FilteredPeriod
        selectedPeriod={selectedPeriod.label}
        comparisonPeriod={comparisonPeriod}
        selectedPeriodicity={selectedPeriodicity}
        isDisplayNoComparisonLabel={isDisplayNoComparisonLabel}
      />
      <DataLastUpdated date={selectedPeriod.lastUpdatedDate} />
      <PanelType scopeMetadata={scopeMetadata} periodicity={selectedPeriodicity} />
    </div>
  ) : null;
};

export default FilterSelectionNote;
